import { Divider, Backdrop, CircularProgress, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import FilterBar from '../components/FilterBar';
import MapSection from '../components/Map/MapSection';

const NetworkBox = styled(Box)(
    ({ theme }) => ({
        paddingTop: "6.4rem",
        display: "flex",
        flexDirection: "column",
        [theme.breakpoints.up("sm")]: {
            paddingTop: "7rem",
        },
    })
);

const MainContent = styled(Box)(
    ({ theme }) => ({
        overflowX: "hidden",
        overflowY: "auto",
        padding: "0 4vw",
    })
);

export default function Network(props) {
    const [filter, setFilter] = useState("All");
    const [dist, setDist] = useState(null);
    const [msg, setMsg] = useState("loading");

    useEffect(() => {
        const fetchDist = async () => (
            fetch(`https://raw.githubusercontent.com/ruh010/locedge-db/master/${filter}/distribution.json`)
                .then((resp) => resp.json())
                .then((data) => setDist(data))
                .catch((exc) => setMsg(`${exc.toString()}. Check your Internet connection. User in China: please use proxy.`))
        );
        fetchDist();
        return () => {
            setDist(null);
            setMsg("loading");
        };
    }, [filter]);

    return (
        <NetworkBox>
            <Divider />
            <FilterBar value={filter} onChange={(_, newVal) => setFilter(newVal)} />
            <MainContent>
                {dist && dist.map((data, idx) => (
                    <MapSection
                        filter={filter}
                        key={idx}
                        id={`continent${idx}`}
                        {...data}
                    />
                ))}
                <Backdrop open={!dist} unmountOnExit sx={{
                    position: "absolute",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    flexDirection: "column",
                    alignItems: "center",
                }}>
                    <CircularProgress color="secondary" />
                    <Typography sx={{
                        margin: 2,
                        fontFamily: "montserrat",
                        fontWeight: 500,
                        display: "block",
                        textAlign: "center",
                    }}>
                        {msg}
                    </Typography>
                </Backdrop>
            </MainContent>
        </NetworkBox>
    );
};